<template>
  <button
    @click="$emit('click')"
    class="btn"
    :class="['btn-' + buttonTypeClass, sizeStyles]"
    :disabled="loading"
  >
    <span v-if="!loading">
      <slot>Button Label</slot>
    </span>
    <Spinner :orange="type == 'secondary'" class="mx-auto" v-if="loading" />
  </button>
</template>

<script>
import Spinner from "@/components/common/Spinner";
export default {
  name: 'StyledButtonComponent',
  components: { Spinner },
  props: {
    type: {
      default: 'secondary',
      type: String
    },
    loading: {
      default: false,
      type: Boolean
    },
    size: {
      default: 'lg',
      type: String
    }
  },

  computed: {
    buttonTypeClass() {
      const types = ["primary", "secondary"];
      return types.includes(this.type) ? this.type : "secondary";
    },
    sizeStyles() {
      switch (this.size) {
        case 'lg':
          return 'px-10 min-w-10 rounded-lg font-semibold';
        break;

        case 'md':
          return 'px-6 py-2 min-w-6 rounded-md text-md font-semibold';
        break;

        case 'sm':
          return 'px-4 py-1 min-w-4 rounded-md text-sm';
        break;

        case 'xs':
          return 'px-2 py-0 min-w-4 text-xs font-normal rounded';
        break;
      }
    }
  }
};
</script>
